
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface DashboardStatsProps {
  contacts: any[];
  orders: any[];
  mentorApplications: any[];
  coachRecommendations: any[];
  coupons: any[];
}

export const DashboardStats = ({
  contacts,
  orders,
  mentorApplications,
  coachRecommendations,
  coupons,
}: DashboardStatsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-8">
      <Card>
        <CardHeader>
          <CardTitle>İletişim Formları</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{contacts.length}</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>Siparişler</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{orders.length}</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>Mentor Başvuruları</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{mentorApplications.length}</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>Koç Önerileri</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{coachRecommendations.length}</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>Kuponlar</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{coupons.length}</p>
        </CardContent>
      </Card>
    </div>
  );
};
